var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.092,
    height: 22.026,
    viewBox: "0 0 22.092 22.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8266",
    "data-name": "Group 8266",
    transform: "translate(-4391.098 -4916.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8265",
    "data-name": "Group 8265",
    transform: "translate(4391.098 4916.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8264",
    "data-name": "Group 8264",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16865",
    "data-name": "Path 16865",
    d: "M4406.683,4941.409a10.123,10.123,0,0,1-5.31-1.644,24.532,24.532,0,0,1-9.134-9.591,8.657,8.657,0,0,1-.978-5.879,4.761,4.761,0,0,1,1.3-2.45,2.094,2.094,0,0,1,2.43-.541,9.369,9.369,0,0,1,4.08,3.308,10.383,10.383,0,0,1,.961,1.7,1.834,1.834,0,0,1-.425,2.291,8.661,8.661,0,0,1-1.315,1.08.771.771,0,0,0-.338,1.057,5.977,5.977,0,0,0,2.1,2.82,12.392,12.392,0,0,0,1.949,1.1c.326.166.575.042.8-.278a12.461,12.461,0,0,1,1.205-1.471,1.871,1.871,0,0,1,2.169-.424,8.417,8.417,0,0,1,2.9,1.935,8.591,8.591,0,0,1,2.128,3.011,2.085,2.085,0,0,1-.63,2.659A5.509,5.509,0,0,1,4406.683,4941.409Zm-.371-1.251a3.871,3.871,0,0,0,3.438-1.294.759.759,0,0,0,.123-.96,15.749,15.749,0,0,0-1.174-1.8,7.593,7.593,0,0,0-2.722-2.183c-.647-.293-.8-.271-1.267.252a9.287,9.287,0,0,0-.8,1.031,1.806,1.806,0,0,1-2.146.864,7.092,7.092,0,0,1-3.541-2.271,6.192,6.192,0,0,1-1.765-3.21,1.749,1.749,0,0,1,.776-1.873c.428-.292.825-.629,1.235-.948a.774.774,0,0,0,.254-1.024,8.141,8.141,0,0,0-4.14-4.119.942.942,0,0,0-.768.12,3.193,3.193,0,0,0-1.365,2.252,6.16,6.16,0,0,0,.565,3.476,22.208,22.208,0,0,0,10.266,10.706A7.84,7.84,0,0,0,4406.313,4940.158Z",
    transform: "translate(-4391.098 -4919.383)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16866",
    "data-name": "Path 16866",
    d: "M4422.4,4925.814a7.882,7.882,0,0,1-1.2-.518,1.952,1.952,0,0,1-.937-1.686c-.014-1.741-.033-3.482,0-5.222a2.08,2.08,0,0,1,2.09-2.087q3.69-.052,7.381,0a2.138,2.138,0,0,1,2.1,2.2q.046,2.533,0,5.071a2.157,2.157,0,0,1-2.152,2.149.744.744,0,0,1-.151,0,5.27,5.27,0,0,0-4.3,1.28,9.609,9.609,0,0,1-1.6,1.033,1.113,1.113,0,0,1-.863.1,1.026,1.026,0,0,1-.357-.741A15.785,15.785,0,0,1,4422.4,4925.814Zm1.4.39c.607-.39,1.151-.684,1.631-1.062a3.7,3.7,0,0,1,2.877-.872,7.329,7.329,0,0,0,1,.006c.841,0,1.144-.3,1.147-1.154q.01-2.235,0-4.471c0-.665-.289-.977-.936-.98q-3.468-.016-6.934,0a.832.832,0,0,0-.946.926q-.02,2.362,0,4.724a.83.83,0,0,0,.9.918c.083,0,.167,0,.251,0,.792.011,1,.224,1,1.027C4423.793,4925.546,4423.792,4925.824,4423.792,4926.2Z",
    transform: "translate(-4409.772 -4916.275)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_16867",
    "data-name": "Path 16867",
    d: "M4442.224,4927.879a.889.889,0,0,1-.069-1.774.888.888,0,0,1,.069,1.774Z",
    transform: "translate(-32.19 -6.297)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16868",
    "data-name": "Path 16868",
    d: "M4435.333,4927.879a.889.889,0,0,1-.069-1.774.888.888,0,0,1,.069,1.774Z",
    transform: "translate(-27.776 -6.297)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16869",
    "data-name": "Path 16869",
    d: "M4428.442,4927.879a.889.889,0,0,1-.07-1.774.888.888,0,0,1,.07,1.774Z",
    transform: "translate(-23.362 -6.297)",
    fill: "#7e97b8",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.761751be4dfde1c79f47a397bb7c6af2.svg";
export { ForwardRef as ReactComponent };